/* eslint-disable @typescript-eslint/unbound-method */
import { TFunction } from 'i18next';
import { GAME_API_PREFIX } from '../constants/api';
import { ApiClient } from './ApiClient';
import { SolvedChallengesReportEntry } from '../types/SolvedChallengesReportEntry';

export class JamDashboardAPI {
  constructor(private apiClient: ApiClient, private t: TFunction) {
    // do nothing
  }

  public fetchSolvedChallenges(eventId: string, challengeId: string): Promise<SolvedChallengesReportEntry[]> {
    return this.apiClient.get({
      path: `${GAME_API_PREFIX}/event/${eventId}/${challengeId}/stats/teams/solved`,
    }) as Promise<SolvedChallengesReportEntry[]>;
  }
}
